import React from "react";
import "./SectionB.css";


const SectionB = () => {
 
 
  return (
    <div className="">
     
      <div className="boss container pt-3 " >
        <div className=" btn btn-white  fs-sm ps-3 pe-3 me-2 rounded-pill">
          Dates
        </div>
        <div className=" btn btn-white  fs-sm ps-3 pe-3 me-2 rounded-pill">
          Group 
        </div>
        <div className=" btn btn-white  fs-sm ps-3 pe-3 me-3 rounded-pill">
          More 
        </div>
        <span className="bg-danger line me-3"></span>
       <div >
       
        <div className=" btn btn-white  fs-ssm ps-3 pe-3 me-2 rounded-pill">
          Dance
        </div>
        <div className=" btn btn-white  fs-ssm ps-3 pe-3 me-2 rounded-pill">
          Drinks
        </div>
        <div className=" btn btn-white  fs-ssm ps-3 pe-3 me-2 rounded-pill">
          Entertainment
        </div>
        <div className=" btn btn-white  fs-ssm ps-3 pe-3 me-2 rounded-pill">
          Fitness
        </div>
        <div className=" btn btn-white  fs-ssm ps-3 pe-3 me-2 rounded-pill">
          History & culture
        </div>
        <div className=" btn btn-white  fs-ssm ps-3 pe-3 me-2 rounded-pill">
          Magic
        </div>
        <div className=" btn btn-white  fs-ssm ps-3 pe-3 me-2 rounded-pill">
          Music
        </div>
        <div className=" btn btn-white  fs-ssm ps-3 pe-3 me-2 rounded-pill">
          Social impact
        </div>
        <div className=" btn btn-white  fs-ssm ps-3 pe-3 me-2 rounded-pill">
          Wellness
        </div>
        <div className=" btn btn-white  fs-ssm ps-3 pe-3 me-2 rounded-pill">
          Olympians & Paralympians
        </div>
        <div className=" btn btn-white  fs-ssm ps-3 pe-3 me-2 rounded-pill">
          Designed for accessibilit
        </div>
       </div>
      </div>
    </div>
  );
};

export default SectionB;
